import { BandInfo, BoxStyleInfo, FormatInfo } from '@photosi/expo-photosi-sdk/build/PrintUtils';
import { TBaseButtonProps } from '@photosi/rn-components/buttons/base-button/BaseButton.types';
import { GROUP_CODES } from 'src/constants/code.constants';
import { ConfigurationStepId } from 'src/helpers/configurationSteps.helper';
export interface CardProps<T> {
  item: T;
  index: number;
  isSelected?: boolean;
  onPress: (item: T) => void;
  onFocus: TBaseButtonProps['onFocus'];
  productGroup: GROUP_CODES;
}

export interface InfoPageProps {
  step: ConfigurationStepId;
  card: FormatInfo;
  productGroup: GROUP_CODES;
}
export type StepInfo = FormatInfo | BandInfo | BoxStyleInfo;
export interface StepProps {
  step: ConfigurationStepId;
  onSelectCard: (id: string) => void;
  onSelectCardMobile: (id: string) => void;
  cards: StepInfo[];
  productGroup: GROUP_CODES;
}

export enum Arrows {
  SHOW_LEFT = 'SHOW_LEFT',
  SHOW_RIGHT = 'SHOW_RIGHT',
  SHOW_BOTH = 'SHOW_BOTH',
  HIDDEN = 'HIDDEN',
}
